import initialState from 'modules/profile-initial';
import apiService from 'services/apiService';
import { actions } from 'react-redux-form';

import { refreshToken } from './authentication';

export const UPDATE_PROPERTIES = 'profile/UPDATE_PROPERTIES';
export const SUBMITTED_RESET = 'profile/SUBMITTED_RESET';
export const PROFILE_REQUEST = 'profile/PROFILE_REQUEST';
export const PROFILE_SUCCESS = 'profile/PROFILE_SUCCESS';
export const PROFILE_FAILURE = 'profile/PROFILE_FAILURE';

export const FILL_PROFILE_FROM_USER = 'FILL_PROFILE_FROM_USER';

/**
 * REDUCER
 * --------------------------------------------------------- *
 */
const profile = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PROPERTIES:
      return {
        ...state,
        properties: {
          ...action.properties,
        },
      };

    case PROFILE_REQUEST:
      return {
        ...state,
      };
    case PROFILE_SUCCESS:
      return {
        ...state,
        submitted: true,
        submitFailed: false,
      };
    case SUBMITTED_RESET:
      return {
        ...state,
        submitted: false,
        submitFailed: false,
      };
    case FILL_PROFILE_FROM_USER: {
      return {
        ...state,
        properties: {
          ...state.properties,
          ...action.properties,
        },
      };
    }
    case PROFILE_FAILURE:
      return {
        ...state,
        submitFailed: true,
      };
    default:
      return state;
  }
};

export default profile;


/**
 * ACTIONS
 * --------------------------------------------------------- *
 */

/**
 * profile action
 * updateProfileProperties add or update an object of properties
 * @param  {object} properties : object of properties to add / update in profile object
 */
export const updateProfileProperties = properties => (dispatch, getState) => {
  dispatch(actions.reset('profile'));
  dispatch({
    type: UPDATE_PROPERTIES,
    properties: {
      ...initialState.properties,
      ...getState().authentication.payload.user.properties,
      ...properties,
    },
  });
};

/**
 * profile async action : post profile informations
 * @param {number}
 * @param {string}
 */
export const submitProfile = (email, properties, uuid) => async dispatch => {
  dispatch({ type: PROFILE_REQUEST });

  try {
    await apiService.request('/accounts/user/', {
      method: 'PUT',
      body: JSON.stringify({
        email,
        properties,
        uuid,
      }),
    });
    dispatch({ type: PROFILE_SUCCESS,
      data: {
        email,
        properties,
      } });
    dispatch(refreshToken());
  } catch (error) {
    dispatch({ type: PROFILE_FAILURE, error });
  }
};

export const resetSiretValidation = () => dispatch => {
  dispatch(actions.resetValidity('profile.properties.structure.siret'));
};

export const resetSubmitted = () => ({ type: SUBMITTED_RESET });



// WEBPACK FOOTER //
// ./src/modules/profile.js